import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, FormControlLabel, Checkbox, FormHelperText} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';

export default class CheckboxField extends React.Component {
    static propTypes = {
        form: formShape.isRequired,
        name: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
        rules: PropTypes.array.isRequired,
        initialValue: PropTypes.bool.isRequired,
        helpText: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        disabled: PropTypes.bool.isRequired,
    };
    static defaultProps = {
        rules: [],
        initialValue: false,
        helpText: '',
        color: 'primary',
        disabled: false,
    };

    render() {
        const {
            name,
            label,
            color,
            helpText,
            rules,
            initialValue,
            disabled,
            form: {getFieldProps, getFieldError},
        } = this.props;
        let errors = getFieldError(name);
        let hasError = !isEmpty(errors);
        let error;
        if (hasError) {
            error = errors[0];
        }

        const fieldProps = getFieldProps(name, {
            validate: [
                {trigger: 'onBlur', rules},
                {trigger: 'onChange', rules},
            ],
            initialValue,
        });

        return (
            <FormGroup className="mui-form-group">
                <FormControl error={hasError}>
                    <FormControlLabel
                        name={name}
                        label={label}
                        control={
                            <Checkbox
                                {...fieldProps}
                                checked={fieldProps.value}
                                onChange={e => {
                                    this.props.onChange ? this.props.onChange(e) :
                                        fieldProps.onChange(e.target.checked);
                                }}
                                color={color}
                                style={{paddingTop: 0, paddingBottom: 0}}
                                disabled={disabled}
                            />
                        }
                    />
                    {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
                    <FormHelperText error={hasError}>{error}</FormHelperText>
                </FormControl>
            </FormGroup>
        );
    }
}
